import { render } from "./BaseBadge.vue?vue&type=template&id=25a906e4&scoped=true"
import script from "./BaseBadge.vue?vue&type=script&lang=js"
export * from "./BaseBadge.vue?vue&type=script&lang=js"

import "./BaseBadge.vue?vue&type=style&index=0&id=25a906e4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\THULIB\\Documents\\GitHub\\Coach-Finder-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25a906e4"]])

export default __exports__